import React from 'react';
import TableCell from "@mui/material/TableCell";
import styles from './OrderCell.module.css';

const DirectionIcon = (direction) => {
    switch (direction) {
        case 'desc':
            return styles.orderCellDirectionDesc;
        case 'asc':
            return  styles.orderCellDirectionAsc;
        case 'none':
            return styles.orderCellDirectionNone;
    }
};

function OrderCell({label, ordersBundle, orderField, sticky, id, style }) {
    const rule = ordersBundle.getRule(orderField);
    return <TableCell id={id} className={styles.orderCell} style={style} onClick={() => ordersBundle.toggleField(orderField)}
                      sx={sticky}><span className={ `${styles.orderCellDirection} ${DirectionIcon(rule.direction)}`}><span className={styles.orderIndex}>{rule.index > 0? rule.index: ''}</span> {label}</span></TableCell>;
}

export default OrderCell;